import './Footer.css';
import { Link } from 'react-router-dom';
import React from 'react';
import { strings } from '../../../localization/Localization';
import { useAuth } from '../../Auth/AuthContext';

const Footer = () => {
  const { isAdmin } = useAuth();

  return (
    <>
      <div>
        <div className={'middle-section footer-dark py-3'}>
          <div className={'container row'}>
            <div className={'col-3'}><h5 className='ms-4'>{strings.AtlantikTurs}</h5></div>
            <div className={'col-4'}>
              <p className={'m-0'}>{strings.Skopje}</p>
              <p className={'m-0'}>{strings.phoneFax}: +389 (0)2 3109 825</p>
              <p className={'m-0'}>{strings.phoneFax}: +389 (0)2 3109 826</p>
              <p className={'m-0'}>{strings.email}: info-sk@atlantikturs.com</p>
            </div>
            <div className={'col-4'}>
              <p className={'m-0'}>{strings.Kavadarci}</p>
              <p className={'m-0'}>{strings.phoneFax}: +389 (0)43 420 885</p>
              <p className={'m-0'}>{strings.phoneFax}: +389 (0)43 412 885</p>
              <p className={'m-0'}>{strings.phoneFax}: +389 (0)43 413 885</p>
              <p className={'m-0'}>{strings.email}: info@atlantikturs.com</p>
              <p className={'m-0'}>{strings.email}: atlantik_kav@yahoo.com</p>
            </div>
            <div className='col-1'>
              <ul>
                <li className={'me-4'}><Link to='/home'>{strings.home}</Link></li>
                <li className={'me-4'}><Link to='/clients'>{strings.clients}</Link></li>
                <li className={'me-4'}><Link to='/excursions'>{strings.excursions}</Link></li>
                {isAdmin && (
                  <li className={'me-4'}><Link to='/employees'>{strings.employees}</Link></li>
                )}
              </ul>
              {/* <p className={"small"}>© JCh</p> */}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Footer;